module.exports = __webpack_public_path__ + "img/email-expired.6b5cb612.png";